import * as React from "react";

import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 text-foreground",
        className,
      )}
      ref={ref}
      {...props}
      {...(type === "number" && { onWheel: event => event.currentTarget.blur() })} // Prevents scrolling on number inputs
    />
  );
});
Input.displayName = "Input";

export { Input };
